<template>
    <div>
        <BaseModal
            :isVisible="modalStatus"
            :title="title"
            size="lg"
            @close="clean"
        >
            <template v-slot:content>
                <div class="reservation-details">
                    <SectionContainer
                        title="Dados da Reserva"
                        icon="calendar-check"
                    >
                        <!-- Header com imagem e informações principais -->
                        <div class="reservation-header">
                            <div class="row w-100">
                                <div class="col-md-7">
                                    <ImageVehicle :vehicle-data="data.vehicles"/>
                                </div>
                                <div class="col-md-5">
                                    <div class="main-info-section h-100">
                                        <div class="status-row">
                                            <span
                                                class="status-badge"
                                                :class="getStatusClass(data.reserve_status)"
                                            >
                                                <i class="fas fa-info-circle"></i>
                                                {{ status[data.reserve_status - 1] }}
                                            </span>
                                            <div class="reservation-number">
                                                #{{ data.id }}
                                            </div>
                                        </div>

                                        <div class="user-info-compact justify-content-between">
                                            <span class="user-name">
                                                <i class="fas fa-user"></i>
                                                {{ data.user && data.user.name }}
                                            </span>
                                            <button
                                                class="btn btn-sm btn-outline-primary"
                                                @click="openUserModal"
                                                title="Dados do Usuário"
                                            >
                                                <i class="fas fa-user"></i>
                                            </button>
                                        </div>

                                        <router-link
                                            class="mt-auto mb-3"
                                            :to="'/myreserves/view/' + data.id"
                                            @click="clean"
                                        >
                                            <button
                                                class="btn btn-primary"
                                                title="Visualizar detalhes da Reserva"
                                            >
                                                <i class="fas fa-eye mr-2"></i>
                                                Ver Detalhes
                                            </button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- Grid de informações compactas -->
                        <div class="info-grid">
                            <div class="info-item">
                                <i class="fas fa-map-marker-alt"></i>
                                <div>
                                    <span class="info-label">Cidade Destino:</span>
                                    <span class="info-value">{{
                                            data.city_destination && data.city_destination.city_destination && data.city_destination.city_destination.description
                                                             }}
                                    </span>
                                </div>
                            </div>

                            <div class="info-item">
                                <i class="fas fa-calendar-alt"></i>
                                <div>
                                    <span class="info-label">Retirada:</span>
                                    <span class="info-value date-highlight">{{ data.retreat_date }}</span>
                                </div>
                            </div>

                            <div
                                class="info-item"
                                v-if="data.checkout"
                            >
                                <i class="fas fa-calendar-check"></i>
                                <div>
                                    <span class="info-label">Retirado Em:</span>
                                    <span class="info-value date-highlight">{{ data.checkout.retreat_at }}</span>
                                </div>
                            </div>

                            <div class="info-item">
                                <i class="fas fa-calendar-times"></i>
                                <div>
                                    <span class="info-label">Devolução:</span>
                                    <span class="info-value date-highlight">{{ data.devolution_date }}</span>
                                </div>
                            </div>

                            <div class="info-item" v-if="data.km_traveled">
                                <i class="fas fa-tachometer-alt"></i>
                                <div>
                                    <span class="info-label">Km Rodados:</span>
                                    <span class="info-value km-value">
                                        {{ formatNumber(data.km_traveled) }} km
                                    </span>
                                </div>
                            </div>
                        </div>
                    </SectionContainer>
                </div>

                <!-- Histórico de Viagens -->
                <LastTripsTable
                    :vehicle-data="data.vehicles"
                    :trips-data="data.last_trips"
                    :show-pagination="show_paginate"
                    :pagination-options="options"
                    @open-trip-details="openModal"
                    @load-page="paginate"
                />
            </template>
        </BaseModal>

        <Loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        />
    </div>
</template>

<script>
import BaseModal from '../Base/BaseModal.vue'
import SectionContainer from './Checklist/SectionContainer.vue'
import LastTripsTable from './Components/LastTripsTable.vue'
import ImageVehicle from './Components/ImageVehicle.vue'
import Loading from 'vue-loading-overlay'

export default {
    name: "PendencyModal", // Nome do componente em inglês: Modal de Pendência
    components: {
        BaseModal,
        SectionContainer,
        LastTripsTable,
        ImageVehicle,
        Loading
    },
    emits: ['get-paginate', 'changeModal', 'OMDCk', 'open-user-modal'],
    props: {
        pendency: { // pendency - dados da pendência/reserva
            required: true
        },
        title: { // title - título do modal
            type: String,
            required: true,
        },
        modalStatus: { // modalStatus - status se o modal está aberto ou fechado
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            km: " km", // km - unidade de quilometragem
            index: 0, // index - índice para controle
            data: {}, // data - dados da reserva
            isLoading: false, // isLoading - estado de carregamento
            fullPage: true, // fullPage - carregamento em tela cheia
            show_paginate: false, // show_paginate - controla exibição da paginação
            options: { // options - opções de paginação
                texts: {
                    count: "Mostrando de {from} a {to} de {count} registros",
                },
                page: 1,
                chunk: 4,
                chunksNavigation: "fixed",
            },
            status: ['Pré-reserva', 'Reservado', 'Cancelado', 'Retirado', 'Devolvido'], // status - lista de status da reserva
        };
    },
    watch: {
        modalStatus: function (newStatus) { // modalStatus - observa mudanças no status do modal
            this.options.page = 1;
            setTimeout(() => {
                this.show_paginate = true;
            }, 50)
        },
        pendency: function (newPendency) { // pendency - observa mudanças nos dados da pendência
            this.data = {...newPendency}
        }
    },
    mounted() {
        this.data = {...this.pendency}
    },
    methods: {
        formatNumber(value) { // formatNumber - formatar números com separadores
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        getStatusClass(status) { // getStatusClass - retorna classe CSS baseada no status
            const statusClasses = {
                1: 'status-pending', // Pré-reserva
                2: 'status-approved', // Reservado
                3: 'status-canceled', // Cancelado
                4: 'status-progress', // Retirado
                5: 'status-completed' // Devolvido
            };
            return statusClasses[status] || 'status-unknown';
        },
        paginate(page) { // paginate - controlar paginação
            var data = {
                id: this.data.id,
                vehicle: this.data.vehicles.id,
                index: page
            };
            this.$emit('get-paginate', data)
        },
        openModal(object) { // openModal - abrir modal de detalhes de viagem
            this.$emit("OMDCk", object);
        },
        openUserModal() { // openUserModal - abrir modal do usuário
            this.$emit("open-user-modal", this.data);
            this.clean();
        },
        clean() { // clean - limpar dados e fechar modal
            this.$emit("changeModal", false);
            this.options.page = 1;
        },
    },
};
</script>

<style scoped>
.reservation-details {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Header com imagem e informações principais */
.reservation-header {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
    background-color: var(--light-gray);
    border-radius: 8px;
    padding: 15px;
}

.vehicle-image-section {
    flex: 0 0 200px;
}

.main-info-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.status-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.reservation-number {
    font-size: 18px;
    font-weight: bold;
    color: var(--secondary-color);
}

.vehicle-info h5 {
    margin: 0 0 8px 0;
    color: var(--secondary-color);
    font-size: 16px;
}

.plate-container {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background-color: var(--primary-color);
    color: white;
    padding: 4px 10px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 14px;
}

.user-info-compact {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-name {
    display: flex;
    align-items: center;
    gap: 5px;
    font-weight: 600;
    color: var(--secondary-color);
}

/* Grid de informações compactas */
.info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
    margin-bottom: 20px;
}

.info-item {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: var(--light-gray);
    padding: 12px;
    border-radius: 6px;
    border-left: 4px solid var(--primary-color);
}

.info-item i {
    color: var(--primary-color);
    font-size: 16px;
    width: 20px;
    text-align: center;
}

.info-item div {
    flex: 1;
}

.info-label {
    display: block;
    font-size: 12px;
    color: var(--text-color);
    margin-bottom: 2px;
}

.info-value {
    display: block;
    font-weight: 600;
    color: #2c3e50;
}

.date-highlight {
    color: var(--primary-color) !important;
}

.km-value {
    color: var(--secondary-color) !important;
}

.action-buttons {
    display: flex;
    justify-content: flex-end;
}

.action-buttons .btn {
    min-width: 140px;
}

/* Classes de status usando as variáveis CSS existentes */
.status-pending {
    background-color: #ffe5cc;
    color: #995c00;
}

.status-approved {
    background-color: #d4edda;
    color: #155724;
}

.status-canceled {
    background-color: #f8d7da;
    color: #721c24;
}

.status-progress {
    background-color: #cce5ff;
    color: #004085;
}

.status-completed {
    background-color: #d1e7dd;
    color: #0f5132;
}

.status-unknown {
    background-color: #e2e3e5;
    color: #383d41;
}

/* Responsividade */
@media (max-width: 768px) {
    .reservation-header {
        flex-direction: column;
    }

    .vehicle-image-section {
        flex: none;
    }

    .status-row {
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
    }

    .info-grid {
        grid-template-columns: 1fr;
    }

    .action-buttons {
        justify-content: center;
    }

    .action-buttons .btn {
        width: 100%;
    }

    .user-info-compact {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/PendencyModal.vue